import { SweetModal, SweetModalTab } from './main.js'

export default {
	install(Vue, options) {
		Vue.component('SweetModal', SweetModal)
		Vue.component('SweetModalTab', SweetModalTab)
	}
}


// WEBPACK FOOTER //
// ./node_modules/sweet-modal-vue/src/plugin.js